import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { PopupsService } from '@services';
import { ConstantsUtil } from '@utils';
import { Popups, Routes } from '@enums';
import { Icon } from '@elements/icon';
import { AuthPageWrapper, StyledIconButton } from './auth-pages-layout.styles';
import close from '@images/delete.svg';
import logo from '@images/logo.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Auth page layout hoc component.
 *
 * @author Ihar Kazlouski
 * @function AuthPagesLayoutHoc
 * @category Hocs
 * @param {ReactNode} children children.
 * @return {JSX.Element} wrapped component.
 */
var AuthPagesLayoutHoc = function AuthPagesLayoutHoc(_ref) {
  var children = _ref.children,
      title = _ref.title;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var navigate = useNavigate();
  var location = useLocation();
  var isLoginScreen = location.pathname === Routes.Login;
  /**
   * Close handler.
   *
   * @function handleClose
   * @author Ihar Kazlouski
   * @return {void}
   */

  var handleClose = function handleClose() {
    void PopupsService.open(Popups.Default, {
      header: t('components.popups.unsavedChanges'),
      body: t('components.popups.areYouSure'),
      acceptButton: t('components.popups.ok'),
      rejectButton: t('components.popups.cancel')
    }).then(function () {
      localStorage.removeItem(ConstantsUtil.localStorage.keysContainer);
      navigate(Routes.Login);
    })["catch"](function () {// ToDo: error handling
    });
  };

  return /*#__PURE__*/_jsxs(AuthPageWrapper, {
    children: [!isLoginScreen && /*#__PURE__*/_jsx(StyledIconButton, {
      onClick: handleClose,
      children: /*#__PURE__*/_jsx(Icon, {
        src: close,
        width: 24,
        height: 24
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      width: "100%",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsxs(Stack, {
        mb: 1,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Icon, {
          src: logo,
          width: 120,
          height: 60
        }), /*#__PURE__*/_jsx(Typography, {
          mt: 5.5,
          variant: "h4",
          fontWeight: "bold",
          textAlign: "center",
          children: title || t('pages.auth.adminPanel')
        })]
      }), children]
    })]
  });
};

export { AuthPagesLayoutHoc };